export default function phoneValidator(value) {
  return `${value}`.match(/^[2-9]\d{9}$/);
}
